export enum MultiFactor {
  APP = 'app',
  EMAIL = 'email',
  SMS = 'sms',
}


export enum TipoAccion {
  CUENTA = 'cuenta',
  ESTABLECIMIENTO = 'establecimiento',
  SUSCRIPCION = 'suscripcion',
}
